import { render, staticRenderFns } from "./ImageDrawing.vue?vue&type=template&id=56e08ffe&functional=true&"
import script from "./ImageDrawing.vue?vue&type=script&lang=js&"
export * from "./ImageDrawing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../mobile.zyp.one/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports